module.exports = __webpack_public_path__ + "img/rotate-left.036228b4.png";